import React from 'react';
import {
  useGetMovieVideosQuery,
  useGetTvVideosQuery,
} from '../../services/movieApi';

const MovieTrailers = ({ movieId, tvId }) => {
  console.log(tvId);
  const { data: movieTrailers } = useGetMovieVideosQuery({
    movieId,
  });

  const { data: tvTrailers } = useGetTvVideosQuery({
    tvId,
  });
  console.log(tvTrailers?.results);

  return (
    <div className="bg-black w-full h-full text-white py-10 px-4 flex flex-col gap-4 xl:gap-6">
      {movieId && (
        <>
          {movieTrailers?.results.slice(0, 4).map((value, i) => (
            <div className="flex flex-col max-w-md w-full mx-auto sm:max-w-lg md:max-w-xl lg:max-w-3xl xl:max-w-4xl 2xl:max-w-5xl ">
              <h1 className="font-bold  lg:text-xl lg:mb-3 2xl:text-2xl 2xl:mb-4">
                {value.name}
              </h1>
              <iframe
                src={`https://www.youtube.com/embed/${value.key}`}
                className="w-full aspect-square lg:aspect-video "
              />
            </div>
          ))}
        </>
      )}
      {tvId && (
        <>
          {tvTrailers?.results?.length > 0 ? (
            <>
              {tvTrailers?.results.slice(0, 4).map((value, i) => (
                <div className="flex flex-col max-w-md w-full mx-auto sm:max-w-lg md:max-w-xl lg:max-w-3xl xl:max-w-4xl 2xl:max-w-5xl ">
                  <h1 className="font-bold  lg:text-xl lg:mb-3 2xl:text-2xl 2xl:mb-4">
                    {value.name}
                  </h1>
                  <iframe
                    src={`https://www.youtube.com/embed/${value.key}`}
                    className="w-full aspect-square lg:aspect-video "
                  />
                </div>
              ))}
            </>
          ) : (
            <div className="w-full px-4 container mx-auto h-96 flex justify-center items-center">
              No Have Trailer
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MovieTrailers;
